import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { SidebarNavGroupComponent } from './sidebar-nav/sidebar-nav.component'
// import { SidebarNavGroupComponent } from './sidebar-nav-group/sidebar-nav-group.component'

export interface SidebarAction {
    open?: boolean
    sidebarNavGroup?: SidebarNavGroupComponent
}

@Injectable()
export class SidebarNavGroupService {
    private sidebarNavGroupState = new BehaviorSubject<SidebarAction>({})
    sidebarNavGroupState$ = this.sidebarNavGroupState.asObservable()

    toggle(action: SidebarAction): void {
        this.sidebarNavGroupState.next(action)
    }
}
